import { FunctionComponent } from "react";
import { IconProps } from "./constants";

const ExclaimationMark: FunctionComponent<IconProps> = ({
  width = 4,
  height = 30,
  color = "#305953",
  ...props
}: IconProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 4 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-name={props.name || "exclaimation"}
      data-testid={props.name || "exclaimation"}
      {...props}
    >
      <path d="M2 2L2 19" stroke={color} strokeWidth="3.5" strokeLinecap="round" />
      <path d="M2 2L2 19" stroke="black" strokeOpacity="0.2" strokeWidth="3.5" strokeLinecap="round" />
      <path d="M2 27L2 28" stroke={color} strokeWidth="3.5" strokeLinecap="round" />
      <path d="M2 27L2 28" stroke="black" strokeOpacity="0.2" strokeWidth="3.5" strokeLinecap="round" />
    </svg>
  );
};

export default ExclaimationMark;
